import { render, staticRenderFns } from "./otherQuestion.vue?vue&type=template&id=f70bb6a0&scoped=true"
import script from "./otherQuestion.vue?vue&type=script&lang=js"
export * from "./otherQuestion.vue?vue&type=script&lang=js"
import style0 from "./otherQuestion.vue?vue&type=style&index=0&id=f70bb6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70bb6a0",
  null
  
)

export default component.exports